import { FIFA_TO_ISO2 } from '../lib/flags';

interface FlagProps {
  code: string;
  size?: number;
}

const PLACEHOLDER_RE = /^([12][A-L]|3[A-L]{4,6}|(W|RU)\d{1,3}|TBA)$/;

export function Flag({ code, size = 28 }: FlagProps) {
  const iso = FIFA_TO_ISO2[code];
  const radius = size * 0.18;
  if (!iso) {
    const isPlaceholder = PLACEHOLDER_RE.test(code);
    const tileStyle = {
      width: size,
      height: size,
      borderRadius: radius,
      background: '#e5e3da',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#0f1e3d',
      flexShrink: 0,
    } as const;
    if (isPlaceholder) {
      const iconSize = Math.round(size * 0.55);
      return (
        <div style={{ ...tileStyle, color: '#9aa3b2' }} aria-label="Drużyna nieznana">
          <svg
            width={iconSize}
            height={iconSize}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M7 4h10v5a5 5 0 0 1-10 0z" />
            <path d="M5 6H3a3 3 0 0 0 3 3M19 6h2a3 3 0 0 1-3 3M9 21h6M12 15v6" />
          </svg>
        </div>
      );
    }
    return (
      <div
        style={{
          ...tileStyle,
          fontWeight: 700,
          fontSize: Math.round(size * 0.34),
          letterSpacing: '0.02em',
        }}
      >
        {code}
      </div>
    );
  }
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        overflow: 'hidden',
        boxShadow: '0 1px 2px rgba(15,30,61,.18), inset 0 0 0 0.5px rgba(15,30,61,.08)',
        flexShrink: 0,
        background: '#f4f3ee',
      }}
    >
      <img
        src={`https://flagcdn.com/${iso}.svg`}
        alt={code}
        width={size}
        height={size}
        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
      />
    </div>
  );
}
